import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from '@/lib/v2/components';

import { useService } from '@/src/infrastructure/Protocol/useEmblue';

export const useTag = () => {
  const service = useService();
  const { t } = useTranslation();

  /** DON’T REPLICATE CODE LIKE THIS, THE NEXT COPY AND PASTE, PLEASE REFACTOR */
  const createTag = useCallback(
    async (value: string) => {
      const responseCreate = await service?.createTag(value);
      const OkBody = t('MANAGE_TAG_MODAL.NOTIFICATION.OkBody');
      let alertBody = t('MANAGE_TAG_MODAL.NOTIFICATION.KoBody');
      let result = false;

      /* cspell:disable */
      if (responseCreate['notification']['content'].id_notificacion === 'CREAR_TAG_OK') {
        result = true;
      }
      if (responseCreate['notification']['content'].id_notificacion === 'CREAR_TAG_KO') {
        alertBody = t('MANAGE_TAG_MODAL.NOTIFICATION.KoBody');
      }
      if (responseCreate['notification']['content'].id_notificacion === 'TAG_EXISTENTE_OK') {
        alertBody = t('MANAGE_TAG_MODAL.NOTIFICATION.ExistingBody');
      }
      if (responseCreate['notification']['content'].id_notificacion === 'TAG_DUPLICADO') {
        alertBody = t('MANAGE_TAG_MODAL.NOTIFICATION.DuplicateBody');
      }
      /* cspell:enable */

      if (result) service?.incrementLastRefreshTagsValue();

      toast({
        title: result
          ? t('MANAGE_TAG_MODAL.NOTIFICATION.OkTitle')
          : t('MANAGE_TAG_MODAL.NOTIFICATION.AlertTitle'),
        body: result ? OkBody : alertBody,
        variant: result ? 'success' : 'error',
      });

      return result;
    },
    [service, t]
  );

  return { createTag };
};
